module.exports = __webpack_public_path__ + "static/media/SCR-A-new1.0881bcdd.mp3";